module.exports = __webpack_public_path__ + "img/user-sc-icon.0d97af8c.png";